import React from 'react';
import { LineChart, Line, ResponsiveContainer, Tooltip } from 'recharts';

/**
 * Enhanced Sparkline - Mini chart for KPI tiles
 * Features:
 * - Smooth animations
 * - Accessible tooltip
 * - Multiple color themes
 */

const strokeColors = {
  primary: '#1E40AF',
  green: '#059669',
  accent: '#10B981',
  bharat: '#DF8C4D',
  link: '#007AFF',
  purple: '#570683',
  warning: '#D97706',
  danger: '#DC2626',
};

// Custom tooltip component defined outside render
const SparklineTooltipContent = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-gray-900 text-white px-2 py-1 rounded text-xs shadow-lg">
        {payload[0].value?.toLocaleString()}
      </div>
    );
  }
  return null;
};

const Sparkline = ({ 
  data = [], 
  stroke = 'primary',
  height = 48,
  showTooltip = true,
  className = '',
  dataKey = 'value',
}) => {
  if (!data || data.length === 0) return null;
  
  const color = strokeColors[stroke] || stroke;
  
  // Normalize data format
  const chartData = data.map((item, index) => ({
    index,
    value: typeof item === 'object' ? item[dataKey] || item.value : item,
  }));

  return (
    <div 
      className={className}
      role="img" 
      aria-label="Trend sparkline chart"
    >
      <ResponsiveContainer width="100%" height={height}>
        <LineChart data={chartData} margin={{ top: 5, right: 5, bottom: 5, left: 5 }}>
          <Line
            type="monotone"
            dataKey="value"
            stroke={color}
            strokeWidth={2}
            dot={false}
            activeDot={showTooltip ? { r: 4, fill: color } : false}
            animationDuration={500}
            animationEasing="ease-out"
          />
          {showTooltip && (
            <Tooltip content={<SparklineTooltipContent />} />
          )}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Sparkline;
